module.exports = __webpack_public_path__ + "img/img55.d97dfc4b.svg";